import { render } from "./IconChevronRight.vue?vue&type=template&id=6b9021e4"
import script from "./IconChevronRight.vue?vue&type=script&lang=js"
export * from "./IconChevronRight.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__